package com.neurobs.ccabserver.transcriptreview.components.transcriptselection.components

import com.neurobs.ccab.AccountDataRest
import com.neurobs.ccab.db.AccountData
import com.neurobs.react.semanticui.UiDropdownFactory
import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{ErrorState, TranscriptSelectionState, UserState}
import com.neurobs.js.ccab.{CCABServer, ServerContext}
import com.neurobs.js.http
import com.neurobs.js.util.ServerResponseUtil
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.concurrent.ExecutionContext.Implicits.global

@react
object AccountSelector {

  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val transcriptSelectionState = TranscriptSelectionState.accessState
    val userState = UserState.accessState
	  val server = ServerContext.accessState
    implicit val errorState = ErrorState.accessState

    val (accountSelections, setAccountSelections) = useState[Option[List[AccountDataRest]]](None)


    def userIsAdmin() = userState.userIsSiteAdmin

    def selectAccount(accountId: Long) = {
		 server.getAccount(accountId)._2 map {
			 case Right(data) => transcriptSelectionState.selectAccount(data)
				case Left(_) =>
		 }
	 }

    def loadAllAccountData() = {
		 server.getAccounts()._2 map {
			 case Right(data) => setAccountSelections(Some(data.toList))
			 case Left(_) =>
		 }
	 }

    useEffect(() => {
      if (!userIsAdmin()) {
        selectAccount(userState.accountId)
      } else {
        loadAllAccountData()
      }
    }, Vector())

    def generateAccountDataItem(accountData: AccountDataRest): List[ReactElement] = {
      def selector: () => Unit = () => selectAccount(accountData.id)

      List(
        div(className := "item", key := accountData.id.toString, onClick := selector)(
            UiDropdownFactory.DropdownText(accountData.founderEmail),
            br(),
            UiDropdownFactory.DropdownSubtext("Organization: " + accountData.organization)
        ),
        div(className := "divider", key := (accountData.id.toString + "_divider"))
      )

    }

    if (!userIsAdmin()) {
      transcriptSelectionState.data.value.account match {
        case None => UiDropdownFactory.LoadingDropdown("Getting user account data")
        case Some(account) => UiDropdownFactory.DisabledDropdown(account.founderEmail)
      }
    } else {
      accountSelections match {
        case Some(accounts) =>
          UiDropdownFactory.SelectionDropdown[AccountDataRest](
            placeholder = "Select account",
            selections = accounts,
            itemGenerator = generateAccountDataItem(_),
            selected = transcriptSelectionState.data.value.account,
            displayGenerator = accountData => accountData.founderEmail
          )
        case None => UiDropdownFactory.LoadingDropdown("Loading account data")
      }
    }

  }

}
